module.exports = __webpack_public_path__ + "static/media/newsletter-december-2021-wine-stroll.78da2b82.jpg";